module.exports = __webpack_public_path__ + "img/36.792ef231.png";